import { render, staticRenderFns } from "./mobileCa-detail.vue?vue&type=template&id=1ad5d1b8&scoped=true"
import script from "./mobileCa-detail.vue?vue&type=script&lang=js"
export * from "./mobileCa-detail.vue?vue&type=script&lang=js"
import style0 from "./mobileCa-detail.vue?vue&type=style&index=0&id=1ad5d1b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad5d1b8",
  null
  
)

export default component.exports